/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsneu_Philologie16Inputs */

const en__field_enum_mzsneu_philologie16 = /** @type {(inputs: _Field_Enum_Mzsneu_Philologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modern philologies`)
};

const de__field_enum_mzsneu_philologie16 = /** @type {(inputs: _Field_Enum_Mzsneu_Philologie16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuere Philologien`)
};

/**
* | output |
* | --- |
* | "modern philologies" |
*
* @param {_Field_Enum_Mzsneu_Philologie16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsneu_philologie16 = /** @type {((inputs?: _Field_Enum_Mzsneu_Philologie16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsneu_Philologie16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsneu_philologie16(inputs)
	return de__field_enum_mzsneu_philologie16(inputs)
});
export { _field_enum_mzsneu_philologie16 as "_field_enum_MZSNEU_PHILOLOGIE" }